import React, { createContext, useContext } from "react"

import type { TranscriptParticipantLabels } from "./transcriptParticipants"

const TranscriptParticipantsContext = createContext<
  TranscriptParticipantLabels | undefined
>(undefined)

/**
 * Publishes who the two sides of the conversation are to everything under a
 * surface that draws one. A panel beside the transcript — a metric quoting a
 * turn, say — then names and faces them exactly as the transcript does, rather
 * than resolving them again from whatever it happens to hold.
 */
export const TranscriptParticipantsProvider: React.FC<
  React.PropsWithChildren<{ participants: TranscriptParticipantLabels }>
> = ({ participants, children }) => (
  <TranscriptParticipantsContext.Provider value={participants}>
    {children}
  </TranscriptParticipantsContext.Provider>
)

/** The surrounding transcript's participants, or undefined outside one. */
export const useTranscriptParticipants = ():
  | TranscriptParticipantLabels
  | undefined => useContext(TranscriptParticipantsContext)
